
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import commonUtil from './../../../utils/commonUtil';
// import InputButton from './../../../components/ZUILib/InputButton';
// import { connect } from 'react-redux';
// import { asyncConnect } from 'redux-connect';
// import * as multipleEvetnsContentActions from './../MultipleEvents/actions';
import SelectionTab from './../../../components/ZUILib/SelectionTab';
import * as labelsActions from '../../../components/labels/actions';
import ApplyCSS from './../../../components/ApplyCSS';

// const { isMultiEventContentLoaded, loadMultiEventContent } = multipleEvetnsContentActions;

const { isLablesLoaded, loadLables } = labelsActions;
const channel = commonUtil.getChannel();
@asyncConnect([
  // {
  //   promise: ({ store: { dispatch, getState } }) => {
  //     if (!isMultiEventContentLoaded(getState())) {
  //       return dispatch(loadMultiEventContent());
  //     }
  //     return undefined;
  //   },
  // },
  {
  // deferred: true,
    promise: ({ store: { dispatch, getState } }) => {
      if (!isLablesLoaded(getState())) {
        return dispatch(loadLables());
      }
      return undefined;
    },
  },
])
@connect(store => ({
  lables: store.labels.data,
  content: store.multipleEvents.data,
}),
  { ...labelsActions })
class EventsMaxLimitReached extends Component {
//   constructor(props) {
//     super(props);
//   }
// TODO: When clicks on any event it redirects to admin listing page
  render() {
    const events = [];
    /* eslint-disable */
    const mainDiv = channel === 'web' ? "row" : "row maxEvents";
    const secondaryDiv =  channel === 'web' ? "col-md-8 col-md-offset-2 maxEvent " : "col-xs-12";
    this.props.content.eventList.forEach((e) => {
        if(e.eventStatus === 'Active') {
        const _EventsOptions = {};
        _EventsOptions.id = e.eventId;
        //_EventsOptions.value = e[i];
        _EventsOptions.labelResourceId = e.eventName;
        events.push(_EventsOptions);
        }
    });
    const labels = this.props.lables;
    const pageName = 'EventsMaxLimitReached';
    return (
      <div className={mainDiv}>
        <ApplyCSS pageName={pageName} />
        <div className={secondaryDiv}>
          <h1>{commonUtil.getLabel(labels.EventManagement, 'cg.max.event.reached.message')}</h1>
           {channel==='web' ? <h2>&quot;{commonUtil.getLabel(labels.EventManagement, 'cg.close.some.events.message')}&quot;</h2> : <p>"{commonUtil.getLabel(labels.EventManagement, 'cg.close.some.events.message')}"</p> }
          <div className="cSelect">
          <SelectionTab
          field='event'
          id="selectState"
          options={events}
          // optionCaption={'Selecciona un estado'}
          optionText={'labelResourceId'}
          optionValue={'id'}
          // handleSelectedOption={(id) => this.openStoreDropdown('event', id)}
          disabled={events.length <= 0}
        /><i className="icon-flecha_gruesa_abajo" />
          </div>
        </div>
      </div>
    );
  }
}
export default EventsMaxLimitReached;
